export default __webpack_public_path__ + "static/media/aeroland-branding-picture-01.3eec3c03.png";